import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  headingSpacingValue: 0 | 1;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightIconStatCard',
})(({ brandColors, spacing }, props) => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  subheading: {
    marginTop: spacing(props.headingSpacingValue),
  },
  onDark: {
    '& .primaryTextColor': {
      color: brandColors.white,
    },
    '& .accentTextColor': {
      color: brandColors.tintsOffWhite40,
    },
  },
  onLight: {
    '& .primaryTextColor': {
      color: brandColors.black,
    },
    '& .accentTextColor': {
      color: brandColors.tintsNeutral20,
    },
  },
}));

export default useStyles;
